<template>
  <div class="apply-old">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      label-position="top"
      size="small"
    >
      <div class="person-info clearfix">
        <el-row>
          <el-col>
            <h4
              :hidden="!this.ruleForm.canSubmit"
              style="padding-bottom: 10px; color: red"
            >
              {{ $t("app.applicationDescription") }}
            </h4>
          </el-col>
        </el-row>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.name')" prop="name">
            <el-input v-model="ruleForm.name" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('app.studentNumber')" prop="studentCode">
            <el-input
              v-model="ruleForm.studentCode"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$t('app.currentRoomNumber')"
            prop="roomCode"
            v-show="this.isCurrentHostel"
          >
            <el-input v-model="ruleForm.roomCode" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item
            :label="$t('app.applyView.roomChoose')"
            prop="category"
            ref="category"
            v-show="!this.isCurrentHostel"
          >
            <el-radio-group v-model="ruleForm.category">            
              <el-radio
                :style="
                  !phoneFlag
                    ? { whiteSpace: 'pre-wrap', display: 'block' }
                    : { display: 'block' }
                "
                :label="1"
                >{{ $t("app.roomTypeSelect.noI") }}</el-radio
              ><br />
              <el-radio
                :style="
                  !phoneFlag
                    ? { whiteSpace: 'pre-wrap', display: 'block' }
                    : { display: 'block' }
                "
                :label="2"
                >{{ $t("app.roomTypeSelect.noII") }}</el-radio
              ><br />
              <el-radio
                :style="
                  !phoneFlag
                    ? { whiteSpace: 'pre-wrap', display: 'block' }
                    : { display: 'block' }
                "
                :label="3"
                >{{ $t("app.roomTypeSelect.noIII") }}</el-radio
              ><br />
              <el-radio
                :style="
                  !phoneFlag
                    ? { whiteSpace: 'pre-wrap', display: 'block' }
                    : { display: 'block' }
                "
                :label="4"
                >{{ $t("app.roomTypeSelect.noIIII") }}</el-radio
              >
            </el-radio-group>
          </el-form-item> -->
        </el-col>
        <el-form-item
          :label="$t('app.applyOldView.isContinue')"
          prop="isContinue"
          v-show="this.isCurrentHostel"
        >
          <el-radio-group
            v-model="ruleForm.isContinue"
            @change="isContinueChangeFn"
          >
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="'1'"
              >{{ $t("app.yes") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="'2'"
              >{{ $t("app.applyOldView.noI") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="'3'"
              >{{ $t("app.applyOldView.noII") }}</el-radio
            >
            <br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="'4'"
              >{{ $t("app.applyOldView.noIII") }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <!-- 添加房型選擇 laotang 2023-04-12 -->
        <el-form-item
          :label="$t('app.roomTypeSelect.title')"
          prop="selectedRoomType"          
        >
       
          <el-radio-group
            v-model="ruleForm.selectedRoomType"
            :disabled="!this.isShowRoomTypeSelect"
            >
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="1"
              >{{ $t("app.roomTypeSelect.noI") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="2"
              >{{ $t("app.roomTypeSelect.noII") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="3"
              >{{ $t("app.roomTypeSelect.noIII") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="4"
              >{{ $t("app.roomTypeSelect.noIIII") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="5"
              >{{ $t("app.roomTypeSelect.noIIIII") }}</el-radio
            ><br />
            <el-radio
              :style="
                !phoneFlag
                  ? { whiteSpace: 'pre-wrap', display: 'block' }
                  : { display: 'block' }
              "
              :label="6"
              >{{ $t("app.roomTypeSelect.noIIIIII") }}</el-radio
            >
          </el-radio-group>
          <!-- <br /> -->
        </el-form-item>
        <el-form-item
          :label="$t('app.applyOldView.isKeep')"
          prop="isKeep"
          v-show="this.isCurrentHostel"
        >
          <el-cascader
            :disabled="this.ruleForm.isContinue !== '1'"
            v-model="ruleForm.isKeep"
            :options="options"
            :placeholder="$t('app.validation.select')"
            :props="{ expandTrigger: 'hover' }"
            style="width: 200px"
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('app.otherNeeds')">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="ruleForm.other"
            :style="!phoneFlag ? '' : { width: '600px' }"
          ></el-input>
        </el-form-item>
        <!-- 退宿日期 -->
        <el-form-item
          prop="date"
          :label="$t('app.planCheckOutDate')"
          v-show="this.isCurrentHostel"
        >
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('app.validation.date')"
            v-model="ruleForm.date"
            style="width: 200px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="this.ruleForm.canSubmit"
            :loading="submitting"
            @click="submitForm('ruleForm')"
          >
            {{ $t("app.submit") }}
          </el-button>
          <!-- <el-button size="small" @click="resetForm('ruleForm')">{{
            $t("app.reset")
          }}</el-button> -->
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { submit, getBaseInfo } from "@/api/oldStudent";
export default {
  data() {
    var validateIsKeep = (rule, value, callback) => {
      if (this.ruleForm.isContinue === "1" && value.length <= 0) {
        callback(new Error(this.$t("app.validation.select")));
      } else if (this.ruleForm.isContinue !== "1" && value.length > 0) {
        callback(new Error(this.$t("app.validation.isKeepFalse")));
      } else {
        callback();
      }
    };
    return {
      phoneFlag: false,
      submitting: false,
      isCurrentHostel: true,
      isShowRoomTypeSelect:true,
      options: [
        { value: "1", label: this.$t("app.yes") },
        {
          value: "0",
          label: this.$t("app.no"),
          children: [
            { value: "1", label: this.$t("app.changeRoommates") },
            { value: "2", label: this.$t("app.changeRoomType") },
            { value: "3", label: this.$t("app.changeRoomNumber") }
          ]
        }
      ],
      ruleForm: {
        name: "",
        isContinue: "",
        selectedRoomType: "",
        isKeep: [],
        studentCode: "",
        roomCode: "",
        declareFinal: "",
        date: "",
        other: "",
        canSubmit: true,
        category: ""
      },
      selectedRoomTypeTmp: "",
      rules: {
        name: [
          {
            required: true,
            message: this.$t("app.validation.name"),
            trigger: "blur"
          }
        ],
        isContinue: [
          {
            required: true,
            message: this.$t("app.validation.select"),
            trigger: "blur"
          }
        ],
        isRoomContinue: [
          {
            required: true,
            message: this.$t("app.validation.select"),
            trigger: "blur"
          }
        ],
        isKeep: [{ validator: validateIsKeep, trigger: "blur" }],
        studentCode: [
          {
            required: true,
            message: this.$t("app.validation.studentNumber"),
            trigger: "blur"
          }
        ],
        roomCode: [
          {
            required: true,
            message: this.$t("app.validation.currentRoomNumber"),
            trigger: "blur"
          }
        ],
        date: [
          {
            required: true,
            message: this.$t("app.validation.date"),
            trigger: "change"
          }
        ],
        category: [
          {
            required: false,
            message: this.$t("app.validation.category"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  async created() {
    this.phoneFlag = this.$store.state.Config.device;

    //  const { data} =  await getBaseInfo()

    getBaseInfo().then(res => {
      this.ruleForm.name = res.data.Name;
      this.ruleForm.studentCode = res.data.StudentCode;
      this.ruleForm.roomCode = res.data.CurrentRoom;
      //res.data.CurrentRoom = null;
      //以当前房号字段是否为空或null，确定学生是旧生曾入住(有值为曾入住)还是没曾入住过的
      if (res.data.CurrentRoom) {
        console.log("有房號"+res.data.CurrentRoom);
        this.isCurrentHostel = true;
        this.isShowRoomTypeSelect = true;
      } else {
        console.log("沒有房號");
        this.isCurrentHostel = false;
        this.isShowRoomTypeSelect = true;
      }    
      this.ruleForm.isContinue = res.data.IsContinueLodge;      
      this.ruleForm.selectedRoomType = res.data.SelectedRoomType || 1;
      this.ruleForm.isKeep =
        res.data.IsContinueSameRoom === null
          ? ""
          : res.data.IsContinueSameRoom.split(",");
      this.ruleForm.date =
        res.data.CheckOutDate === null
          ? ""
          : res.data.CheckOutDate.replace(/\//g, "-");
      this.ruleForm.other = res.data.OtherRequirement;
      this.ruleForm.canSubmit = res.data.IsExpired;
      // this.ruleForm.category = res.data.SelectedRoomType || "1";
      this.setRuleRequired();
    });
  },
  mounted() {
    if (this.$refs.mycolor) {
      this.$refs.mycolor.style.setProperty(
        "--wrapSpan",
        !this.phoneFlag ? "pre-wrap" : ""
      );
    }
  },
  watch: {
    phoneFlag(val, oldVal) {
      this.$el.style.setProperty(
        "--wrapSpan",
        !this.phoneFlag ? "pre-wrap" : ""
      );
    },
    "ruleForm.isContinue"(newVal) {
      if (newVal !== "1") {
        this.ruleForm.isKeep = [];
      }
    }
  },
  methods: {
    isContinueChangeFn(e) {
      //console.log(e +"           "+this.ruleForm.isContinue);
      if (this.ruleForm.selectedRoomType && this.ruleForm.selectedRoomType != "0") {
        this.selectedRoomTypeTmp = this.ruleForm.selectedRoomType;
      }
      if (e != 1) {       
        this.ruleForm.selectedRoomType = "0"; 
        this.isShowRoomTypeSelect = false;                     
      } else {
        this.ruleForm.selectedRoomType = this.selectedRoomTypeTmp;
        this.isShowRoomTypeSelect = true; 
      }
      this.ruleForm.isContinue = e; 
    },
    submitForm(formName) {
      const that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.submitting = true;
          submit({
            Name: this.ruleForm.name,
            StudentCode: this.ruleForm.studentCode,
            CurrentRoom: this.ruleForm.roomCode,
            CheckOutDate: this.ruleForm.date,
            IsContinueLodge: this.ruleForm.isContinue,
            SelectedRoomType: this.ruleForm.selectedRoomType,
            IsContinueSameRoom: this.ruleForm.isKeep.join(","),
            OtherRequirement: this.ruleForm.other
          })
            .then(() => {
              this.$message({
                message: this.$t("app.opeSuccess"),
                type: "success"
              });
              that.submitting = false;
              this.$router.push("/oldStu");
            })
            .catch(error => {
              console.log(error);
              that.submitting = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setRuleRequired() {
      this.rules.isContinue[0].required = this.isCurrentHostel;
      this.rules.roomCode[0].required = this.isCurrentHostel;
      this.rules.date[0].required = this.isCurrentHostel;
      this.rules.category[0].required = !this.isCurrentHostel;
    }
  }
};
</script>
<style lang="scss" scoped>
.apply-old {
  overflow: auto;
  .person-info {
    background-color: #fff;
    padding: 15px;
    border: solid 1px #ccc;
  }
}
</style>
<style lang="scss">
.apply-old {
  .person-info {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
      display: block;
      white-space: var(--wrapSpan);
    }
  }
}
</style>
